import queries from '@apis/queries';
import StampApi from '@apis/stamp/StampApi';
import { GetStampHistoriesParams } from '@models/stamp';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getNextPageParam } from '@utils/slice';
import dayjs from 'dayjs';
import { useAtomValue } from 'jotai';

import { historyScopeAtom } from '../../../atoms/stampAtoms';

function useStampHistories() {
    const scope = useAtomValue(historyScopeAtom);
    const startDate = dayjs().subtract(6, 'month').format('YYYY-MM-DD');
    const params: Omit<GetStampHistoriesParams, 'page'> = {
        size: 20,
        shopId: scope?.shopId,
        shopGroupId: scope?.shopGroupId,
        targetScope: scope?.targetScope!,
        startDate,
    };
    const enabled = !!scope?.targetScope;
    const queryInfo = useInfiniteQuery({
        queryKey: queries.stamps.history(params).queryKey,
        queryFn: ({ pageParam }) => StampApi.getStampHistories({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
        enabled: !!scope?.targetScope,
    });
    const histories = getFlattenPageResponse(queryInfo);

    return {
        ...queryInfo,
        histories,
        enabled,
    };
}

export default useStampHistories;
